import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
} from '@mui/material';
import RestoreIcon from '@mui/icons-material/Restore';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

const SavedGameModal = ({
    open,
    onResume,
    onNewGame,
    gameInfo,
}) => {
    // Format saved date
    const formatDate = (isoString) => {
        if (!isoString) return '';
        try {
            const date = new Date(isoString);
            return date.toLocaleString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
            });
        } catch {
            return '';
        }
    };

    // Get game type display name
    const getGameTypeName = (type) => {
        switch (type) {
            case 'ronda': return 'Ronda';
            case 'baciga': return 'Baciga';
            default: return 'Partida';
        }
    };

    return (
        <Dialog
            open={open}
            maxWidth="xs"
            fullWidth
            disableEscapeKeyDown
            onClose={(event, reason) => {
                // Prevent closing by clicking outside
                if (reason === 'backdropClick') return;
            }}
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    background: 'linear-gradient(135deg, #ffffff 0%, #f5f5f5 100%)',
                }
            }}
        >
            <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
                <Typography variant="h6" component="span">
                    🎮 Partida en curso
                </Typography>
            </DialogTitle>
            <DialogContent>
                <Box sx={{ textAlign: 'center', py: 2 }}>
                    <Typography variant="body1" paragraph>
                        Tienes una partida guardada de <strong>{getGameTypeName(gameInfo?.gameType)}</strong>.
                    </Typography>
                    {gameInfo?.savedAt && (
                        <Typography variant="body2" color="text.secondary">
                            Guardada el {formatDate(gameInfo.savedAt)}
                        </Typography>
                    )}
                    <Typography variant="body1" sx={{ mt: 2 }}>
                        ¿Deseas reanudarla?
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', gap: 2, pb: 3, px: 3 }}>
                <Button
                    variant="outlined"
                    color="error"
                    startIcon={<DeleteOutlineIcon />}
                    onClick={onNewGame}
                    sx={{ flex: 1 }}
                >
                    No, nueva partida
                </Button>
                <Button
                    variant="contained"
                    color="success"
                    startIcon={<RestoreIcon />}
                    onClick={onResume}
                    sx={{ flex: 1 }}
                >
                    Sí, reanudar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SavedGameModal;
